



<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>
            &nbsp;&nbsp;&nbsp; Manage User  Preference Settings
        </h2>
    </div>
</div>


<div class="row p-1" *ngIf="status == -1">
    <div class="col-12 pageTitle">
        <h2>
            <span style="padding-left:50px;" class="alert-icon">⚠️</span>
            <span style="text-align:center; font-size: 15px !important; color: #fffa5f;"> You haven’t set your preferences yet. Click below to configure them. </span>
        </h2>
    </div>
</div>


<div class="p-fluid bg-white p-3" id="UserPreferenceSetting">

    <form [formGroup]="frmUserPreferenceSetting" (ngSubmit)="onSubmit()">
        <div>
            <h6 class="col-5 md:col-1 blueBar mb-4 pl-3 pr-3 r-2" style="width: max-content">
                Default Page
            </h6>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6">
                <div class="p-3 border-round surface-card shadow-1">
                    <span class="p-float-label">
                        <p-dropdown formControlName="userDefaultPage"
                                    [options]="userDefaultPageOptions"
                                    optionLabel="value"
                                    optionValue="key"
                                    class="w-full">
                        </p-dropdown>
                        <label>Default Page</label>
                    </span>
                </div>
            </div>

            <div class="col-12 md:col-6">
                <div class="p-3 border-round surface-100 shadow-1"
                     *ngIf="status !== -1">
                    <img style="width:10rem; border-radius:6px"
                         [src]="status === 1
          ? 'assets/imagesNew/timeline.png'
          : 'assets/imagesNew/dashboard.png'" />
                </div>
            </div>
        </div>
        <div>
            <h6 class="col-5 md:col-1 blueBar mb-4 pl-3 pr-3 r-2" style="width: max-content">
                Menu Order
            </h6>
        </div>
        <div class="grid">
            <div class="col-12">
                <div class="p-3 border-round surface-card shadow-1">
                    <p-orderList *ngIf="showOrderList"
                                 [value]="menus"
                                 dragdrop="true"
                                 (onReorder)="onMenuReorder()"
                                 listStyle="height:420px"
                                 class="w-full">

                        <ng-template pTemplate="item" let-menu>
                            <div class="flex justify-content-between align-items-center w-full">
                                <strong>{{ menu.label }}</strong>

                                <!-- optional manual edit -->
                                <input type="number"
                                       pInputText
                                       [(ngModel)]="menu.order"
                                       [ngModelOptions]="{ standalone: true }"
                                       style="width:70px" />
                            </div>
                        </ng-template>

                    </p-orderList>


                </div>

            </div>

        </div>
        <!--<div class="grid mt-4">
        <div class="col-12 text-right">
            <button pButton icon="pi pi-save" label="Save User Preference Settings" type="submit">
            </button>
        </div>
    </div>-->

        <div class="grid mt-4">
            <div class="col-12 text-right flex justify-content-end gap-2">
                <!-- Save -->
                <button pButton
                        type="submit"
                        label="Save User Preference Settings"
                        icon="pi pi-save"
                        class="p-button-primary">
                </button>

                <!-- Reset -->
                <button pButton
                        type="button"
                        label="Reset"
                        icon="pi pi-refresh"
                        class="p-button-warning"
                        (click)="onReset()">
                </button>


                <!-- Cancel -->
                <button pButton
                        type="button"
                        label="Cancel"
                        icon="pi pi-times"
                        class="p-button-secondary"
                        (click)="onCancel()">
                </button>

            </div>
        </div>


    </form>

</div>


<hr style="margin-bottom:0.5rem" />-->





<div class="row p-1">
    <div class="col-12 pageTitle">
        <h2>
            &nbsp;&nbsp;&nbsp; Manage User  Preference Settings
        </h2>
    </div>
</div>


<div class="row p-1" *ngIf="status == -1">
    <div class="col-12 pageTitle">
        <h2>
            <span style="padding-left:50px;" class="alert-icon">⚠️</span>
            <span style="text-align:center; font-size: 15px !important; color: #fffa5f;"> You haven’t set your preferences yet. Click below to configure them. </span>
        </h2>
    </div>
</div>


<div class="p-fluid bg-white p-3" id="UserPreferenceSetting">

    <form [formGroup]="frmUserPreferenceSetting" (ngSubmit)="onSubmit()">


        <div class="grid">
            <div class="col-12">
                <div class="col-6">
                    <div class="p-3 border-round surface-card shadow-1">
                        <h4 class="mb-3">User Default Page</h4>
                        <span class="p-float-label">
                            <p-dropdown formControlName="userDefaultPage"
                                        [options]="userDefaultPageOptions"
                                        optionLabel="value"
                                        optionValue="key"
                                        class="w-full">
                            </p-dropdown>
                            <label>Default Page</label>
                        </span>

                        <!-- Preview -->


                    </div>
                </div>
                <div class="col-6">
                    <div class="p-3 border-round surface-100 shadow-1" *ngIf="status !== -1">
                        <img style="width:10rem; border-radius:6px" [src]="status === 1 ? 'assets/imagesNew/timeline.png': 'assets/imagesNew/dashboard.png'" />
                    </div>
                </div>
            </div>

            <div class="col-12">
                <div class="p-3 border-round surface-card shadow-1">

                    <h4 class="mb-3">Menu Order</h4>

                    <p-orderList *ngIf="showOrderList"
                                 [value]="menus"
                                 dragdrop="true"
                                 (onReorder)="onMenuReorder()"
                                 listStyle="height:420px"
                                 class="w-full">

                        <ng-template pTemplate="item" let-menu>
                            <div class="flex justify-content-between align-items-center w-full">
                                <strong>{{ menu.label }}</strong>

                                <input type="number"
                                       pInputText
                                       [(ngModel)]="menu.order"
                                       [ngModelOptions]="{ standalone: true }"
                                       style="width:70px" />
                            </div>
                        </ng-template>

                    </p-orderList>

                </div>

            </div>

        </div>


        <div class="grid mt-4">
            <div class="col-12 text-right">
                <button pButton icon="pi pi-save" label="Save User Preference Settings" type="submit">
                </button>
            </div>
        </div>

    </form>

</div>


<hr style="margin-bottom:0.5rem" />



